export default __webpack_public_path__ + "static/media/img-connection-success.f395fd85.svg";